import React, { useState } from 'react';

export const LinkediIcon: React.FC = (): JSX.Element => {
  const [hover, setIsHover] = useState(false);
  const onEnter = () => {
    setIsHover(true);
  };
  const onLeave = () => {
    setIsHover(false);
  };

  const fillCol = hover ? '#77A3F9' : '#29335C';

  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={onEnter}
      onMouseLeave={onLeave}
    >
      <circle cx="9" cy="9" r="9" fill="#F7F9FD" />
      <path
        d="M4.16511 7.24865H6.24275V13.9288H4.16511V7.24865ZM5.20393 3.92578C5.86781 3.92578 6.40786 4.46583 6.40786 5.12972C6.40786 5.7936 5.86781 6.33365 5.20393 6.33365C4.53661 6.33365 4 5.7936 4 5.12972C4 4.46583 4.53661 3.92578 5.20393 3.92578Z"
        fill={fillCol}
      />
      <path
        d="M7.54656 7.24909H9.53821V8.16407H9.56572C9.84091 7.63779 10.5185 7.08398 11.5299 7.08398C13.6316 7.08398 14.0203 8.46677 14.0203 10.2658V13.9291H11.9426V10.6786C11.9426 9.9046 11.9289 8.90707 10.8625 8.90707C9.78243 8.90707 9.61732 9.74981 9.61732 10.6235V13.9291H7.54312V7.24909H7.54656Z"
        fill={fillCol}
      />
    </svg>
  );
};
